import React, { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const RATING_STYLE = {
  positive: "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  neutral:  "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
  negative: "text-red-400 bg-red-500/10 border-red-500/20",
};

export default function PeerFeedbackSection() {
  const [feedback, setFeedback] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/performance/peer-feedback`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(d => setFeedback(Array.isArray(d) ? d : d.feedback || []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center gap-2">
        <MessageSquare size={14} className="text-[#00ff90]/60" />
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Peer Feedback</span>
        {!loading && feedback.length > 0 && (
          <span className="ml-auto text-xs text-white/30">{feedback.length} response{feedback.length !== 1 ? "s" : ""}</span>
        )}
      </div>

      <div className="p-5 space-y-3">
        {loading && (
          <div className="space-y-2">
            {[1,2].map(i => <div key={i} className="h-16 rounded-lg bg-white/5 animate-pulse" />)}
          </div>
        )}
        {error   && <p className="text-red-400 text-sm">⚠ {error}</p>}

        {!loading && !error && feedback.length === 0 && (
          <p className="text-white/20 text-sm italic text-center py-4">No peer feedback received yet.</p>
        )}

        {!loading && !error && feedback.map((f, i) => {
          const sentiment = f.sentiment || (f.rating >= 4 ? "positive" : f.rating >= 3 ? "neutral" : "negative");
          const style = RATING_STYLE[sentiment] || RATING_STYLE.neutral;
          return (
            <div key={i} className="rounded-lg border border-white/5 bg-white/3 p-4">
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full bg-[#00ff90]/10 border border-[#00ff90]/20 flex items-center justify-center text-xs font-bold text-[#00ff90] shrink-0">
                    {f.from ? f.from[0].toUpperCase() : "?"}
                  </div>
                  <span className="text-sm text-white/60">{f.from || "Anonymous"}</span>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {f.rating != null && (
                    <span className={`text-xs px-2 py-0.5 rounded-full border ${style}`}>
                      {Number(f.rating).toFixed(1)}
                    </span>
                  )}
                  {f.date && <span className="text-xs text-white/20">{f.date}</span>}
                </div>
              </div>
              {f.comment && <p className="text-sm text-white/60 italic">"{f.comment}"</p>}
              {f.category && <p className="text-xs text-white/25 mt-1 capitalize">{f.category}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}